import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isNullOrUndefined, PhoneNumberUtil } from '../utils';

export class UserValidators {
  static validatePhoneNumber(c: AbstractControl): ValidationErrors | null {
    const validationErrors: ValidationErrors = {};

    if (!isNullOrUndefined(c.value) && c.value.length > 0) {
      try {
        if (!PhoneNumberUtil.isValidPhoneNumber(c.value, PhoneNumberUtil.getCountryCode(c.value))) {
          validationErrors['invalidPhoneNumber'] = true;
        }
      } catch (err) {
        validationErrors['invalidPhoneNumber'] = true;
      }
    }

    return validationErrors;
  }
}
